// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-note {\n  width: 250px;\n}", "",{"version":3,"sources":["webpack://./src/app/cp/inventory/parts/alternatives-threshold/part-alternatives-thresholds.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ","sourcesContent":[".search-note {\n    width: 250px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
